export var source = "query BrandsQuery($input: BrandsInput!) {\n  brands(input: $input) {\n    name\n    count\n  }\n}";
export default source;